module.exports = __webpack_public_path__ + "static/media/humidicula-comum.f219ecfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/humidicula-comum.jpg
// module id = 92
// module chunks = 0